export default "__VITE_ASSET__9yidhCFL__"